import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import NoOrgState from '../pages/NoOrgState';

const ProtectedRoute = ({ children, requiredRoles = [], requiredPermissions = [] }) => {
  const { isAuthenticated, user, permissions, loading } = useAuth();

  if (loading) return <div className="p-8">Loading...</div>;
  if (!isAuthenticated) return <Navigate to="/login" replace />;

  if (requiredRoles && requiredRoles.length) {
    const userRole = user?.role;
    const has = requiredRoles.includes(userRole);
    if (!has) {
      const tenantId = user?.tenant_id;
      if (!tenantId) return <NoOrgState />;
      return <Navigate to="/" replace />;
    }
  }

  if (requiredPermissions && requiredPermissions.length) {
    const userPerms = permissions || [];
    const has = requiredPermissions.every(p => userPerms.includes(p));
    if (!has) {
      const tenantId = user?.tenant_id;
      if (!tenantId) return <NoOrgState />;
      return <Navigate to="/" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
